import * as React from "react";
import { CLASS_FULLSIZE, clsx, cssClass, makeUseContext, PLUGIN_FULLSCREEN } from "../../core/index.js";
const FullscreenContext = React.createContext(null);
export const useFullscreen = makeUseContext("useFullscreen", "FullscreenContext", FullscreenContext);
export const FullscreenContextProvider = ({ children }) => {
    const containerRef = React.useRef(null);
    return (React.createElement("div", { ref: containerRef, className: clsx(cssClass(PLUGIN_FULLSCREEN), cssClass(CLASS_FULLSIZE)) },
        React.createElement(FullscreenContext.Provider, { value: containerRef }, children)));
};
